<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Select } from '@drama/ui'
import FormField from '../NovelFormField.vue'
import NovelPlayerSection from './NovelPlayerSection.vue'
import { useSectionModel } from './section-model.js'
import './novel-sections.css'
const props = defineProps({
  modelValue: { type: Object, required: true }, issues: { type: Array, default: () => [] },
  character_id: { type: String, default: null },
  guided: { type: Boolean, default: false },
})
const emit = defineEmits(['update:modelValue', 'blocked'])
const { t } = useI18n()
const { invalid, write, error } = useSectionModel(props, emit)
const people = computed(() => props.modelValue.characters ?? [])
const positioned_people = computed(() => props.character_id === null ? people.value
  : people.value.filter(person => person.id === props.character_id))
const placeOptions = computed(() => (props.modelValue.locations ?? []).map(place => ({ value: place.id, label: place.name || place.id })))
</script>
<template>
  <section
    class="novel-entity"
    data-testid="novel-overview-positions"
  >
    <NovelPlayerSection
      v-if="character_id === null"
      :model-value="modelValue"
      :issues="issues"
      :guided="guided"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <h4>{{ t('novelStudio.fields.startingPositions') }}</h4>
    <div class="novel-entity__grid">
      <FormField
        :error="error(['initial_state', 'positions', person.id])"
        v-for="person in positioned_people"
        :key="person.id"
        required
        :label="person.name || person.id"
      >
        <Select
          :model-value="modelValue.initial_state?.positions?.[person.id] ?? ''"
          :options="placeOptions"
          :aria-label="t('novelStudio.fields.positionOf', { name: person.name || person.id })"
          :invalid="invalid(['initial_state', 'positions', person.id])"
          :data-path="`initial_state.positions.${person.id}`"
          block
          @update:model-value="write(['initial_state', 'positions', person.id], $event)"
        />
      </FormField>
    </div>
  </section>
</template>
